import { useState, ChangeEvent } from "react";
import { useGetModulesQuery } from "../../../../hooks/AdminManagement/useGetModulesQuery";
import ModuleManagement from "./ModuleManagement";
import { useCreateRoleMutation } from "../../../../hooks/AdminManagement/useCreateRoleMutation";
import { HexColorPicker } from "react-colorful";
import Button from "Components/Button";

export interface Modules {
  name: string;
  description: string;
  key: string;
  id: string;
  colorCode: string;
}

interface Payload {
  name: string;
  description: string;
  modulePermissions: {
    moduleId: string;
    permissions: {
      create: boolean | null;
      read: boolean | null;
      update: boolean | null;
      delete: boolean | null;
    };
  }[];
  colorCode: string;
}

const initialState: Payload = {
  name: "",
  description: "",
  modulePermissions: [],
  colorCode: "",
};

const NewRoleForm = () => {
  const { data: modules } = useGetModulesQuery();
  const [payload, setPayload] = useState<Payload>(initialState);

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setPayload((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const { mutate, isPending } = useCreateRoleMutation();

  const handleSubmit = () => {
    mutate(payload);
  };

  return (
    <div className="px-4">
      <div className="max-w-[800px] mx-auto mt-[30px] border-[1px] border-[#eeeeee] rounded-[10px]">
        <div className="border-b-[1px] border-[#eeeeee]">
          <h3 className="p-[15px]">Create New Role</h3>
        </div>
        <div className="">
          <div className="p-[20px]">
            <label htmlFor="name" className="mt-[20px]">
              Role Name
            </label>
            <input
              name="name"
              type="text"
              placeholder="Role"
              className="px-[15px] mb-[21px] py-[20px] border-[1px] border-[#eeeeee] block mt-[13px] w-full rounded-md"
              value={payload.name}
              onChange={handleInputChange}
            />
            <label htmlFor="colorCode" className="mt-[20px]">
              Select Color Code
            </label>
            <HexColorPicker
              color={payload?.colorCode}
              className="my-[13px]"
              onChange={(newColor) =>
                setPayload({ ...payload, colorCode: newColor })
              }
            />
            <div
              className="mb-[13px] w-[200px] h-[50px] rounded"
              style={{ backgroundColor: payload?.colorCode }}
            ></div>
            <label htmlFor="description" className="mt-[20px]">
              Role Description
            </label>
            <textarea
              name="description"
              placeholder="Description"
              className="h-[170px] resize-none px-[15px] py-[20px] border-[1px] border-[#eeeeee] block mt-[13px] w-full rounded-md"
              value={payload.description}
              onChange={handleInputChange}
            />
          </div>
          <div className="border-t-[#eeeeee] border-r-[#fff] border-l-[#fff] border-[1px] border-b-[#eeeeee] px-[20px] py-[10px] text-[#a8a8a8]">
            Custom Permissions
          </div>

          {modules?.data && (
            <ModuleManagement
              modules={modules}
              payload={payload}
              setPayload={setPayload}
            />
          )}
          <div className="mx-[20px]">
            {/* <button
              onClick={handleSubmit}
              disabled={!payload?.description || !payload?.name}
              className={`rounded-[8px]  p-[22px] text-white my-[20px] w-full ${
                !payload?.description || !payload?.name
                  ? "bg-[#562B00]"
                  : "bg-orange"
              }`}
            >
              Complete
            </button> */}
            <Button
              onClick={handleSubmit}
              disabled={!payload?.description || !payload?.name}
              isLoading={isPending}
              label={"Submit Role"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewRoleForm;
